<div class="bd_login memver_login">
    <div class="container-fluid pl-0 pr-0">
        <div class="row no-gutters">
            <div class="col-md-6">
                <div class="bd_loginimg bdloginimg">
                    <img src="assets/img/img3.jpg" class="login_bg">
                    <div class="bd_loginlogo">
                        <a routerLink="/"><img src="assets/img/logo.png"></a>
                        <div class="bd_logintext">
                            <!-- <h2>E-Trade Platform For <br> Private Sales And Procurement</h2> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 d-flex align-items-center">
                <div class="bd_loginbox bd_memberbox text-center bd_otpbox">
                    <h3>Please enter the one time password to verify your account</h3>
                    <p class="text-muted">{{ otpInfoText }}</p>                   

                    <form method="post" [formGroup]="otpForm">
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <ng-otp-input [config]="{ length: 6, allowNumbersOnly: true }" (onInputChange)="onOtpKeyUp($event)" [class.is-invalid]="( !Global.isInputValid(otpForm, 'otp_code') )"></ng-otp-input>
                            </div>

                            <ng-container *ngIf="otpType == 'user-resetpassword'">
                                <div class="form-group col-sm-12 mt-3 px-4">
                                    <input type="password" appArrowNavigation formControlName="password" placeholder="New Password" [class.is-invalid]="( !Global.isInputValid(otpForm, 'password') )" class="form-control">
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'password', 'required')">
                                        <div>This field is required</div>
                                    </div>
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'password', 'minlength')">
                                        <div>The password must be minimum 6 characters</div>
                                    </div>
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'password', 'maxlength')">
                                        <div>The password must be maximum 20 characters</div>
                                    </div>
                                </div>

                                <div class="form-group col-sm-12 px-4">
                                    <input type="password" appArrowNavigation formControlName="password_confirmation" placeholder="Re-enter New Password" [class.is-invalid]="( !Global.isInputValid(otpForm, 'password_confirmation') )" class="form-control">
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'password_confirmation', 'required')">
                                        <div>This field is required</div>
                                    </div>
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'password_confirmation', 'minlength')">
                                        <div>The password must be minimum 6 characters</div>
                                    </div>
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'password_confirmation', 'maxlength')">
                                        <div>The password must be maximum 20 characters</div>
                                    </div>

                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(otpForm, 'password_confirmation', 'passwordConfirmation')">
                                        <div>The password confirmation didn't matched</div>
                                    </div>
                                </div>
                            </ng-container>


                            <div class="col-12 text-right px-5 my-3">
                                <button type="submit" class="btn" (click)="submit($event)">
                                    <span class="indicator-label">Verify OTP</span>
                                    <span class="indicator-progress">Please wait...
                                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </div>

                            <div class="col-12">
                                <hr>
                            </div>
                            
                            <div class="col-12 bd_signtext mt-3">
                                Didn't received the OTP?
                            </div>

                            <div class="col-4 offset-md-4 mt-3">
                                <button type="button" class="btn btn-dark" (click)="resendOtp($event)" id="resendotp-button">
                                    <span class="indicator-label">Resend</span>
                                    <span class="indicator-progress">sending...
                                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>